import { Link } from 'react-router-dom';
import { Phone, MapPin, Truck, Clock, Shield, Award, ChevronRight } from 'lucide-react';

const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_661024ed-50d4-4d78-a636-dd6004c5bf2a/artifacts/qbikuwfk_Gemini_Generated_Image_1y6kaw1y6kaw1y6k.png";
const PRODUCT_ISOVER = "https://customer-assets.emergentagent.com/job_661024ed-50d4-4d78-a636-dd6004c5bf2a/artifacts/qvk1cqi6_IMG_4268.jpeg";
const PRODUCT_PLACO = "https://customer-assets.emergentagent.com/job_661024ed-50d4-4d78-a636-dd6004c5bf2a/artifacts/9i1zzzg2_IMG_4270.jpeg";
const WORKER_IMAGE = "https://customer-assets.emergentagent.com/job_661024ed-50d4-4d78-a636-dd6004c5bf2a/artifacts/slpy24oj_Gemini_Generated_Image_rlqt31rlqt31rlqt.png";

const HomePage = () => {
  const productos = [
    {
      title: "Aislamientos Acústicos y Térmicos",
      description: "Aislamiento acústico PKB2 exclusivo, lana de roca y lana de vidrio de primeras marcas. Soluciones para aislamiento térmico y acústico en Motril.",
      image: PRODUCT_ISOVER,
      link: "/productos#aislamientos"
    },
    {
      title: "Placas de Yeso Laminado (Pladur)",
      description: "Placas estándar y técnicas. BA13, hidrófugas, ignífugas y más. Tu tienda de yeso laminado en Motril.",
      image: PRODUCT_PLACO,
      link: "/productos#placas"
    },
    {
      title: "Perfilería y Accesorios para Yeso Laminado",
      description: "Montantes, canales, tornillería y todos los accesorios para sistemas de placas de yeso laminado (pladur).",
      image: WORKER_IMAGE,
      link: "/productos#perfileria"
    }
  ];

  const ventajas = [
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Rapidez",
      description: "Disponibilidad inmediata de stock. Atendemos tus pedidos con la agilidad que tu obra necesita."
    },
    {
      icon: <Truck className="w-8 h-8" />,
      title: "Servicio a Obra",
      description: "Entrega en obra en radio de 50 km desde Motril. También recogida en nuestro almacén."
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Calidad Garantizada",
      description: "Trabajamos con las mejores marcas del sector: Placo, Isover, Gypsotech, Danosa y más."
    },
    {
      icon: <Award className="w-8 h-8" />,
      title: "+30 Años de Experiencia",
      description: "Conocemos el sector. Asesoramiento técnico y comercial para profesionales y particulares."
    }
  ];

  return (
    <div className="industrial-bg" data-testid="home-page">
      {/* Hero Section */}
      <section className="relative overflow-hidden" data-testid="hero-section">
        <div className="section-container py-16 lg:py-24">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Text Content */}
            <div className="order-2 lg:order-1">
              <span className="inline-block bg-[#3182CE]/10 text-[#3182CE] font-medium px-4 py-2 rounded-sm text-sm mb-6">
                Polígono Alborán, Motril
              </span>
              <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1A365D] uppercase leading-tight mb-6">
                Especialistas en Yesos y Yeso Laminado (Pladur) en Motril
              </h1>
              <p className="text-lg text-[#4A5568] mb-8 leading-relaxed">
                En <strong>Fornes e Hijos</strong> somos tu proveedor de confianza de materiales para yesistas, 
                escayolistas e instaladores de yeso laminado (pladur) en Motril y alrededores. Suministramos yesos, placas de yeso laminado, 
                aislamientos y sistemas de construcción en seco con la rapidez y profesionalidad que tu obra necesita. 
                Más de <strong>30 años de experiencia</strong> en el sector nos avalan.
              </p>
              
              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <a
                  href="tel:858130213"
                  className="btn-primary flex items-center justify-center gap-2 text-lg cta-btn"
                  data-testid="hero-cta-call"
                >
                  <Phone className="w-5 h-5" />
                  Llamar Ahora
                </a>
                <a
                  href="https://www.google.com/maps/place/Fornes+e+Hijos/@36.7275346,-3.5402629,17z"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-secondary flex items-center justify-center gap-2 text-lg"
                  data-testid="hero-cta-map"
                >
                  <MapPin className="w-5 h-5" />
                  Cómo Llegar
                </a>
              </div>

              {/* Contact Info */}
              <div className="flex flex-col sm:flex-row gap-6 text-sm text-[#4A5568]">
                <div className="flex items-center gap-2">
                  <Phone className="w-4 h-4 text-[#3182CE]" />
                  <span>858 130 213</span>
                </div>
                <div className="flex items-center gap-2">
                  <Clock className="w-4 h-4 text-[#3182CE]" />
                  <span>L-V: 07:30-13:30 / 15:30-18:00</span>
                </div>
              </div>
            </div>

            {/* Hero Image */}
            <div className="order-1 lg:order-2">
              <div className="relative">
                <img
                  src={HERO_IMAGE}
                  alt="Instalación de yeso laminado profesional en Motril"
                  className="w-full h-auto rounded-sm shadow-xl"
                  loading="eager"
                />
                <div className="absolute -bottom-4 -left-4 bg-[#1A365D] text-white px-6 py-3 rounded-sm">
                  <p className="font-heading text-lg font-bold">+30 Años</p>
                  <p className="text-sm text-gray-300">de Experiencia</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Productos Destacados */}
      <section className="py-20 bg-white" data-testid="products-section">
        <div className="section-container">
          <div className="text-center mb-16">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-[#1A365D] uppercase mb-4">
              Materiales para Profesionales en Motril
            </h2>
            <p className="text-lg text-[#4A5568] max-w-2xl mx-auto">
              Todo lo que necesitas para tus proyectos de yesos, yeso laminado (pladur) y aislamientos. 
              Stock disponible y servicio a obra.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {productos.map((producto, index) => (
              <Link
                key={index}
                to={producto.link}
                className="product-card group"
                data-testid={`product-card-${index}`}
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={producto.image}
                    alt={producto.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-heading text-xl font-bold text-[#1A365D] mb-3">
                    {producto.title}
                  </h3>
                  <p className="text-[#4A5568] mb-4">{producto.description}</p>
                  <span className="inline-flex items-center text-[#3182CE] font-medium group-hover:translate-x-2 transition-transform">
                    Ver productos <ChevronRight className="w-4 h-4 ml-1" />
                  </span>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/productos"
              className="btn-primary inline-flex items-center gap-2"
              data-testid="view-all-products"
            >
              Ver Todos los Productos
              <ChevronRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>

      {/* Por Qué Elegirnos */}
      <section className="py-20 industrial-bg" data-testid="why-us-section">
        <div className="section-container">
          <div className="text-center mb-16">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-[#1A365D] uppercase mb-4">
              ¿Por Qué Elegir Fornes e Hijos?
            </h2>
            <p className="text-lg text-[#4A5568] max-w-2xl mx-auto">
              Tu almacén de construcción de confianza en Motril. 
              Servicio profesional para profesionales.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {ventajas.map((ventaja, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-sm border border-gray-200 card-hover text-center"
                data-testid={`advantage-${index}`}
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#3182CE]/10 text-[#3182CE] rounded-sm mb-6">
                  {ventaja.icon}
                </div>
                <h3 className="font-heading text-xl font-bold text-[#1A365D] mb-3">
                  {ventaja.title}
                </h3>
                <p className="text-[#4A5568]">{ventaja.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Servicio a Obra CTA */}
      <section className="py-20 bg-[#1A365D]" data-testid="service-cta-section">
        <div className="section-container">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white uppercase mb-6">
                Servicio a Obra en Motril y Alrededores
              </h2>
              <p className="text-lg text-gray-300 mb-6 leading-relaxed">
                Llevamos los materiales directamente a tu obra. Entrega de yesos, yeso laminado (pladur) y aislamientos 
                en un radio de 50 km desde Motril. También puedes recoger tu pedido en nuestro almacén 
                del Polígono Alborán.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center gap-3 text-gray-300">
                  <div className="w-2 h-2 bg-[#3182CE] rounded-full"></div>
                  Entrega en obra con transporte propio
                </li>
                <li className="flex items-center gap-3 text-gray-300">
                  <div className="w-2 h-2 bg-[#3182CE] rounded-full"></div>
                  Radio de 50 km desde Motril
                </li>
                <li className="flex items-center gap-3 text-gray-300">
                  <div className="w-2 h-2 bg-[#3182CE] rounded-full"></div>
                  Recogida en almacén disponible
                </li>
                <li className="flex items-center gap-3 text-gray-300">
                  <div className="w-2 h-2 bg-[#3182CE] rounded-full"></div>
                  Rapidez y cumplimiento garantizado
                </li>
              </ul>
              <Link
                to="/servicio-obra"
                className="inline-flex items-center gap-2 bg-white text-[#1A365D] font-semibold px-6 py-3 rounded-sm hover:bg-gray-100 transition-colors"
                data-testid="service-cta-link"
              >
                Más Información
                <ChevronRight className="w-5 h-5" />
              </Link>
            </div>
            <div className="hidden lg:block">
              <img
                src={WORKER_IMAGE}
                alt="Servicio de entrega de materiales de construcción en Motril"
                className="w-full h-auto rounded-sm shadow-xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mapa y Contacto */}
      <section className="py-20 bg-white" data-testid="map-section">
        <div className="section-container">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Info */}
            <div>
              <h2 className="font-heading text-3xl sm:text-4xl font-bold text-[#1A365D] uppercase mb-6">
                Visítanos en Motril
              </h2>
              <div className="space-y-6 mb-8">
                <div className="flex items-start gap-4">
                  <MapPin className="w-6 h-6 text-[#3182CE] flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-[#1A365D] mb-1">Dirección</h3>
                    <p className="text-[#4A5568]">
                      Polígono Alborán, C. Mar Cantábrico, Nave 3<br />
                      18613 Motril, Granada
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Phone className="w-6 h-6 text-[#3182CE] flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-[#1A365D] mb-1">Teléfonos</h3>
                    <p className="text-[#4A5568]">
                      <a href="tel:858130213" className="hover:text-[#3182CE]">858 130 213</a><br />
                      <a href="tel:622339574" className="hover:text-[#3182CE]">622 339 574</a> (Asesoramiento Técnico y Comercial)
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Clock className="w-6 h-6 text-[#3182CE] flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-[#1A365D] mb-1">Horario</h3>
                    <p className="text-[#4A5568]">
                      Lunes a Viernes: 07:30-13:30 y 15:30-18:00<br />
                      Sábados: Solo bajo pedido
                    </p>
                  </div>
                </div>
              </div>
              <a
                href="tel:858130213"
                className="btn-primary inline-flex items-center gap-2"
                data-testid="map-cta-call"
              >
                <Phone className="w-5 h-5" />
                Llámanos Ahora
              </a>
            </div>

            {/* Map */}
            <div className="map-container" data-testid="google-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3191.8147!2d-3.5402629!3d36.7275346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd719b848677d48f%3A0x79efd0ad4173b1c3!2sFornes%20e%20Hijos!5e0!3m2!1ses!2ses!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación de Fornes e Hijos en Motril"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
